import { GitCommitHorizontal, KeyRound, ShieldCheck } from "lucide-react";

const Chip = ({ icon: Icon, children }) => (
  <div className="inline-flex items-center gap-2 rounded-md border border-slate-800 bg-slate-950/50 px-3 py-1.5">
    <Icon className="h-3.5 w-3.5 text-cyan-400" />
    <span className="mono text-[10px] text-cyan-300/90 tracking-wide whitespace-nowrap">
      {children}
    </span>
  </div>
);

export const ArchitectureReference = () => (
  <div
    data-testid="architecture-reference-bar"
    className="rounded-xl border border-slate-800/80 bg-[#080d16]/80 px-4 py-3 flex flex-col lg:flex-row lg:items-center gap-3 lg:gap-5"
  >
    <div className="flex flex-wrap items-center gap-2">
      <Chip icon={KeyRound}>Dual Ed25519 signatures</Chip>
      <Chip icon={GitCommitHorizontal}>BLAKE2b hash-chained ledger</Chip>
      <Chip icon={ShieldCheck}>Human-in-the-loop approval</Chip>
    </div>
    <div className="flex flex-1 flex-wrap items-center gap-3 lg:justify-end">
      <span className="mono text-[10px] text-slate-500 tracking-wide">
        Telemetry is simulated for demonstration. Signatures and the hash chain are real and independently verifiable.
      </span>
    </div>
  </div>
);
